// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DictionariesSearchRequestDto } from '../models';
// @ts-ignore
import type { DictionariesSearchResponseDto } from '../models';
// @ts-ignore
import type { DictionariesSortValuesDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * DictionariesSearchRestApi - axios parameter creator
 */
export const DictionariesSearchRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search dictionaries
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {DictionariesSortValuesDto} dictionariesSort 
         * @param {DictionariesSearchRequestDto} dictionariesSearchRequestDto Companies search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDictionaries: async (page: number, pageSize: number, sortDirection: SortDirectionDto, dictionariesSort: DictionariesSortValuesDto, dictionariesSearchRequestDto: DictionariesSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchDictionaries', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchDictionaries', 'pageSize', pageSize)
            // verify required parameter 'sortDirection' is not null or undefined
            assertParamExists('searchDictionaries', 'sortDirection', sortDirection)
            // verify required parameter 'dictionariesSort' is not null or undefined
            assertParamExists('searchDictionaries', 'dictionariesSort', dictionariesSort)
            // verify required parameter 'dictionariesSearchRequestDto' is not null or undefined
            assertParamExists('searchDictionaries', 'dictionariesSearchRequestDto', dictionariesSearchRequestDto)
            const localVarPath = `/api/v2/dictionaries/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (dictionariesSort !== undefined) {
                localVarQueryParameter['dictionariesSort'] = dictionariesSort;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dictionariesSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionariesSearchRestApi - functional programming interface
 */
export const DictionariesSearchRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DictionariesSearchRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Search dictionaries
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {DictionariesSortValuesDto} dictionariesSort 
         * @param {DictionariesSearchRequestDto} dictionariesSearchRequestDto Companies search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDictionaries(page: number, pageSize: number, sortDirection: SortDirectionDto, dictionariesSort: DictionariesSortValuesDto, dictionariesSearchRequestDto: DictionariesSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionariesSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDictionaries(page, pageSize, sortDirection, dictionariesSort, dictionariesSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesSearchRestApi.searchDictionaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DictionariesSearchRestApi - factory interface
 */
export const DictionariesSearchRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DictionariesSearchRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Search dictionaries
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {DictionariesSortValuesDto} dictionariesSort 
         * @param {DictionariesSearchRequestDto} dictionariesSearchRequestDto Companies search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDictionaries(page: number, pageSize: number, sortDirection: SortDirectionDto, dictionariesSort: DictionariesSortValuesDto, dictionariesSearchRequestDto: DictionariesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionariesSearchResponseDto> {
            return localVarFp.searchDictionaries(page, pageSize, sortDirection, dictionariesSort, dictionariesSearchRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DictionariesSearchRestApi - interface
 */
export interface DictionariesSearchRestApiInterface {
    /**
     * 
     * @summary Search dictionaries
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SortDirectionDto} sortDirection 
     * @param {DictionariesSortValuesDto} dictionariesSort 
     * @param {DictionariesSearchRequestDto} dictionariesSearchRequestDto Companies search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchDictionaries(page: number, pageSize: number, sortDirection: SortDirectionDto, dictionariesSort: DictionariesSortValuesDto, dictionariesSearchRequestDto: DictionariesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionariesSearchResponseDto>;

}

/**
 * DictionariesSearchRestApi - object-oriented interface
 */
export class DictionariesSearchRestApi extends BaseAPI implements DictionariesSearchRestApiInterface {
    /**
     * 
     * @summary Search dictionaries
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SortDirectionDto} sortDirection 
     * @param {DictionariesSortValuesDto} dictionariesSort 
     * @param {DictionariesSearchRequestDto} dictionariesSearchRequestDto Companies search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchDictionaries(page: number, pageSize: number, sortDirection: SortDirectionDto, dictionariesSort: DictionariesSortValuesDto, dictionariesSearchRequestDto: DictionariesSearchRequestDto, options?: RawAxiosRequestConfig) {
        return DictionariesSearchRestApiFp(this.configuration).searchDictionaries(page, pageSize, sortDirection, dictionariesSort, dictionariesSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

